import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import api from '@/request/index'
import global from '@/constants/Global.constants'

Vue.use(Vuex)

//乘法
function Mul(arg1, arg2) {
    let r1 = arg1.toString(),
      r2 = arg2.toString(),
      m,
      resultVal,
      d = arguments[2];
    m =
      (r1.split(".")[1] ? r1.split(".")[1].length : 0) +
      (r2.split(".")[1] ? r2.split(".")[1].length : 0);
    resultVal =
      (Number(r1.replace(".", "")) * Number(r2.replace(".", ""))) /
      Math.pow(10, m);
    return typeof d !== "number"
      ? Number(resultVal)
      : Number(resultVal.toFixed(parseInt(d)));
}

// 价格优惠
async function getDiscountAmount(state) {
    let arr = []
    
    

    return arr
}
  
export default new Vuex.Store({
    state: {
        user: localStorage.getItem('user'), // 用户
        cartList: [], // 购物车列表
        selectedCart: [], // 选中的购物车商品
        exChangeCartList: [], //兑换商城购物车列表
        exChangeCartCount: 0, // 兑换商城购物车数量
        cartCount: 0, // 购物车数量,
        token: Cookies.get('token'),
        noLoginCartData: Cookies.get('noLoginCartData'),
        breadcrumbList: [], // 面包屑
        navHeadFixed: false, // 是否固定在顶部
        arr: [], // 暂存数据
    },
    getters: {
        cartList: state => state.cartList,
        noLoginCartData: state => state.noLoginCartData && JSON.parse(state.noLoginCartData || {}),
        user: state => JSON.parse(state.user || {})
    },
    mutations: {
        setNavHeadFixed(state, payload) {
            state.navHeadFixed = payload
        },
        // 设置token  expires: 1 / 24
        setToken(state, token) {
            state.token = token
            Cookies.set('token', token, {
                expires: 1
            })
        },
        // 存储没登录前加入购物车的数据
        setNoLoginCartData(state, payload) {
            state.noLoginCartData = payload,
            Cookies.set('noLoginCartData', payload, {
                expires: 1
            })
        },
        // 更新用户名
        updateUserInfo(state, user) {
            state.user = user
            localStorage.setItem('user', user)
        },
        // 更新购物车
        updateCart(state, cart) {
            state.cartList = cart.arr || cart.cartList
            state.cartCount = parseInt(cart.count)
        },
        // 更新选中的购物车商品
        updateSelectedCart(state, selectedCart) {
            state.selectedCart = selectedCart
        },
        // 更新兑换商城购物车
        updateExchangCart(state, cart) {
            state.exChangeCartList = cart.cartList
            state.exChangeCartCount = parseInt(cart.count)
        },
        //  清空购物车
        clearCartCount(state) {
            state.cartCount = 0
        },
        //  初始化购物车数量
        initCartCount(state, count) {
            state.cartCount = count
        },
        updateBreadcrumbList(state, list) {
            state.breadcrumbList = list
            sessionStorage.setItem('breadcrumbList', JSON.stringify(list))
        }
    },
    actions: {
        setToken({
            commit
        }, token) {
            return new Promise((resolve, reject) => {
                commit('setToken', token)
                resolve()
            })
        },
        setNoLoginCartData({
            commit
        }, payload) {
            return new Promise((resolve, reject) => {
                commit('setNoLoginCartData', JSON.stringify(payload || {}))
                resolve
            })
        },
        updateUserInfo({
            commit
        }, user) {
            return new Promise((resolve, reject) => {
                commit('updateUserInfo', user)
                resolve()
            })
        },
        updateCart({
            state,
            commit
        }, projectId) {
            return new Promise((resolve, reject) => {
                if (!localStorage.getItem('user')) return false
                api.goods.getCartList({
                    data: {
                        customerId: JSON.parse(localStorage.getItem('user')).userInfoId,
                        projectId,
                        orderUserType: 'D'
                    },
                    pageIndex: 0,
                    pageSize: 100
                }).then(async res => {
                    if (res.data.code === '0000') {
                        let cartList = res.data.data
                        let count = cartList.length

                        let arr = []
                        let res2 = await axios({
                            method: 'POST',
                            url: global.IMS_ORDER + "/sales/getDiscountAmount",
                            data: {
                                data: {
                                    customerId: JSON.parse(state.user).userInfoId,
                                    orderUserType: "D",
                                    productIds: cartList.map((x) => x.productId).filter((x) => x),
                                },
                                asp: '10'
                            },
                            headers: {
                                certificate: state.token
                            }
                        })
                        if (res2.data.status === "Y") {
                            const data = res2.data.data;
                            arr = cartList.map(item => {
                                let newPrice = 0
                                let selectedItem = data.discountItem.find(
                                    (x) => x.productId === item.productId
                                ) || {}
                                // 判断是否是特价产品 区分会员和经销商
                                if(item.orderUserType === 'D') { // 经销商
                                    if(selectedItem.dealerSpecialOfferFlag === 'Y') {
                                        item.cc = Number(selectedItem.dealerSpecialOffer.toFixed(2))
                                        item.isSpecialOffer = true
                                    } else {
                                        if (selectedItem.productPrice != item.retailPrice) {
                                            item.cc = Number(selectedItem.productPrice.toFixed(2))
                                        }
                                        delete item.isSpecialOffer
                                    }
                                } else {
                                    newPrice = selectedItem.productPrice;
                                    if (item.retailPrice > newPrice) {
                                        item.total = Mul(
                                            item.quantity,
                                            item.cc || item.productPrice
                                        ).toFixed(2);
                                    }
                                    item.cc = Number(newPrice.toFixed(2))
                                }
                                return item
                            })
                        }
                
                        commit('updateCart', {
                            arr,
                            count
                        })
                        resolve()
                    }
                })
            })
        },
        updateExchangCart({ commit }) {
            return new Promise((resolve, reject) => {
                if (!localStorage.getItem('user')) return false
                api.goods.findAllExchangeCart({
                    data: {
                        customerId: JSON.parse(localStorage.getItem('user')).userInfoId
                    },
                    pageIndex: 0,
                    pageSize: 100
                }).then(res => {
                    if (res.data.code === '0000') {
                        let cartList = res.data.data
                        let count = cartList.length
                        commit('updateExchangCart', {
                            cartList,
                            count
                        })
                        resolve()
                    }
                })
            })
        },
        clearCartCount({
            commit
        }) {
            return new Promise((resolve, reject) => {
                commit('clearCartCount')
                resolve()
            })
        },
        initCartCount({
            commit
        }, count) {
            return new Promise((resolve, reject) => {
                commit('initCartCount', count)
                resolve()
            })
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js